// this file is automatically generated by git.version.ts script
export const versions = {version: '4.0.0', revision: 'd0de177dda10fcbbfd20f93aba37b428e23f9fe0'};